import { ElementContext } from 'global/cnr/contexts/ElementContext';
import { FrameworkContext } from 'global/cnr/contexts/FrameworkContent';
import { ParentContext } from 'global/cnr/contexts/ParentContext';
import { useAppUserAccess } from 'global/cnr/contexts/useHelpers/useAppUserAccess';
import TreeViewer from 'global/components/viewers/TreeViewer';
import { createRefPath_event } from 'global/firestoreData/appData/appRefPaths';
import FullPageWrapper from 'global/wrappers/FullPageWrapper';
import Wrapper, { wrapperTypes } from 'global/wrappers/Wrapper';
import _ from 'lodash';
import { useContext, useEffect, useMemo, useState } from 'react';

export const _gamificationTypes = {
  appUser: 'appUser',
  item: 'item'
}

export const UiInteractions = ({ handleCancel, showType }) => {

  const appUserAccess = useAppUserAccess()
  const { appUserSession } = appUserAccess ?? {}
  const { appUserSessionKey } = appUserSession ?? {}

  const parentContext = useContext(ParentContext);
  const { states, fns } = parentContext ?? {}
  const { currentSettings_state, paps_state, eventInfo_state } = states
  const { database_fns } = fns
  const { pathViews } = paps_state ?? {}
  const { aps_global } = _.get(currentSettings_state, 'gvviSettings', {});
  const { appNetworking } = aps_global ?? {}
  const { allowNetworking } = appNetworking ?? {}
  const { appDataDocuments } = eventInfo_state ?? {}

  const frameworkContext = useContext(FrameworkContext);
  const { framework_state } = frameworkContext ?? {}
  const { isMobileDevice: _isMobileDevice } = framework_state ?? {}

  const elementContext = useContext(ElementContext)
  const { element_state } = elementContext ?? {}
  const { itemData: itemData_elem } = element_state ?? {}
  const { _itemKey } = itemData_elem ?? {}

  const [interactionData, setInteractionData] = useState({})

  useEffect(() => {
    const cb1 = (data) => {
      const datas = {}
      if (data) {
        _.forEach(data, (dataItems, dataKey) => {
          const appDataDocument = appDataDocuments?.[dataKey]
          if (!datas[dataKey]) { datas[dataKey] = {} }
          _.forEach(dataItems, (dataItem, dataItemKey) => {
            if (appDataDocument?.[dataItemKey]) {
              datas[dataKey][dataItemKey] = appDataDocument[dataItemKey]
            }
          })
        })
        setInteractionData(datas)
      }
    }
    const _refPath1 = showType === 'itemInteractions' ? createRefPath_event(pathViews, ['_appUserInteractions', _itemKey]) : createRefPath_event(pathViews, ['_appUserInteractions', appUserSessionKey])
    database_fns.get_data
      ({ refPath: _refPath1, callback: cb1, opts: { returnFirstObject: true, ignoreId: true } })
  }, []);

  const _topperCaption = useMemo(() => {
    return 'Interactions';
  }, [])

  const content = () => {
    return <TreeViewer data={interactionData} scNames={true} subNames={true} />
  }

  const wrapper = () => <Wrapper
    content={content()}
    wrapperType={wrapperTypes.padded}
  />

  const fullPageWrapper = () => <FullPageWrapper
    content={wrapper()}
    handleCancel={handleCancel}
    topperCaption={_topperCaption}
    wrapperCss={{ container: 'app-dark-mode' }}
  />

  return fullPageWrapper()
}
